export default "__VITE_ASSET__CrIAVqqq__"